// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewsBox-space1-WFrzr {
	margin-bottom: 6px !important;
}

.NewsBox-space2-sl3Qm {
	margin-bottom: 12px !important;
}

.NewsBox-space3-T7IST {
	margin-bottom: 18px !important;
}

.NewsBox-space4-_r4n6 {
	margin-bottom: 24px !important;
}

.NewsBox-space5-yIDEX {
	margin-bottom: 30px !important;
}

.NewsBox-space6-crl3O {
	margin-bottom: 36px !important;
}

.NewsBox-space7-HbYOZ {
	margin-bottom: 42px !important;
}

.NewsBox-spaceTop8-uBrZp {
	margin-bottom: 48px !important;
}

.NewsBox-spaceTop1-PhIqr {
	margin-top: 6px !important;
}

.NewsBox-spaceTop2-VUPxo {
	margin-top: 12px !important;
}

.NewsBox-spaceTop3-qKpsV {
	margin-top: 18px !important;
}

.NewsBox-spaceTop4-ksfKC {
	margin-top: 24px !important;
}

.NewsBox-spaceTop5-ANz3e {
	margin-top: 30px !important;
}

.NewsBox-spaceTop6-F64bo {
	margin-top: 36px !important;
}

.NewsBox-spaceTop7-BHTTo {
	margin-top: 42px !important;
}

.NewsBox-spaceTop8-uBrZp {
	margin-top: 48px !important;
}

.NewsBox-noMargin-jfCcv {
	margin: 0px !important;
}

.NewsBox-padding1-_3kgR {
	padding-bottom: 6px !important;
}

.NewsBox-padding2-SDshh {
	padding-bottom: 12px !important;
}

.NewsBox-padding3-NKe6k {
	padding-bottom: 18px !important;
}

.NewsBox-padding4-8fA25 {
	padding-bottom: 24px !important;
}

.NewsBox-padding5-e5UFW {
	padding-bottom: 30px !important;
}

.NewsBox-padding6-jJUXQ {
	padding-bottom: 36px !important;
}

.NewsBox-padding7-lc8LD {
	padding-bottom: 42px !important;
}

.NewsBox-paddingTop1-qpCny {
	padding-top: 6px !important;
}

.NewsBox-paddingTop2-RlTDU {
	padding-top: 12px !important;
}

.NewsBox-paddingTop3-J5s7Q {
	padding-top: 18px !important;
}

.NewsBox-paddingTop4-_7q1_ {
	padding-top: 24px !important;
}

.NewsBox-paddingTop5-fw3RG {
	padding-top: 30px !important;
}

.NewsBox-paddingTop6-uy5Mp {
	padding-top: 36px !important;
}

.NewsBox-paddingTop7-ZbKMC {
	padding-top: 42px !important;
}

.NewsBox-noPadding-IRBOZ {
	padding: 0px !important;
}

.NewsBox-textBold-BYkk_ {
	font-weight: 500 !important;
}

.NewsBox-textBolder-BX2X6 {
	font-weight: 700 !important;
}

.NewsBox-textNormal-zlt1g {
	font-weight: normal !important;
}

.NewsBox-spaceBottom20-up41Q {
	margin-bottom: 20px;
}

.NewsBox-spaceBottom10-Yl2CZ {
	margin-bottom: 10px;
}

.NewsBox-marginNone-Y_VyF {
	margin: 0;
}

.NewsBox-spaceBottom15-Bc3xn {
	margin-bottom: 15px;
}

.NewsBox-marginTopNone-XiCAP {
	margin-top: 0;
}

.NewsBox-spaceTop11-PxoeM {
	margin-top: 11px;
}

.NewsBox-spaceTop21-SY6m_ {
	margin-top: 21px;
}

.NewsBox-spaceTop20-DCh9B {
	margin-top: 20px;
}

.NewsBox-spaceTop10-LtlcG {
	margin-top: 10px;
}

/*New Design Text Colors */

.NewsBox-textDarkBlue-fvFCb {
	color: rgb(20, 39, 94) !important;
}

.NewsBox-textLightBlue-RQJ03 {
	color: rgb(57, 87, 106) !important;
}

.NewsBox-textLightSandleGreen-gB_am {
	color: rgb(76, 86, 41) !important;
}

.NewsBox-textLightBrown-e4vGX {
	color: rgb(115, 79, 33) !important;
}

.NewsBox-textMediumMaroon-9qM4a {
	color: rgb(87, 37, 51) !important;
}

.NewsBox-textBrown-xZz7G {
	color: rgb(160, 47, 24) !important;
}

.NewsBox-textMaroon-k2Pwl {
	color: rgb(155, 49, 67) !important;
}

.NewsBox-textDarkBrown-PUL4J {
	color: rgb(83, 18, 16) !important;
}

.NewsBox-textMediumBrown-fHCDo {
	color: rgb(142, 28, 10) !important;
}

.NewsBox-textSkyBlue-dmnYi {
	color: rgb(37, 117, 141) !important;
}

.NewsBox-textGray-H_rnp {
	color: rgb(77, 65, 51) !important;
}

/** Common - Start **/

a,
a:hover,
a:active a:focus {
	text-decoration: none;
	cursor: pointer;
}

/** Common - End **/

/** News box - Start */

.NewsBox-table-sOB2I {
	width: 100%;
	display: table;
	margin-bottom: 48px;
	padding-top: 35px;
}

.NewsBox-tableCell-wp2SP {
	display: table-cell;
	vertical-align: middle;
}

.NewsBox-textColumn-h0xIi {
	width: 45%;
	padding-right: 80px;
}

.NewsBox-imageColumn-evJeR {
	width: 55%;
}

.NewsBox-imgShadow-Txmac {
	width: 70%;
	float: right;
}

.NewsBox-title-C4Drf {
	font-weight: 600;
	color: var(--common-primary-white-foreground);
	margin: 0px;
	font-size: 55px;
	line-height: 65px;
}

.NewsBox-caption-XVdPj {
	font-weight: 200;
	color: var(--primary-foreground);
	margin-top: 12px;
	margin-bottom: 24px;
	word-wrap: break-word;
	font-size: 19px;
	line-height: 24px;
	padding-top: 0px;
	padding-bottom: 0px;
}

.NewsBox-mobileView-b8PhA {
	display: none;
}

.NewsBox-bg-EYklG {
	width: 100%;
	min-height: 400px;
	background-size: cover;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	border-radius: 22px;
	padding: 70px;
	position: relative;
	overflow: hidden;
}

.NewsBox-btn-b3XQU {
	border-radius: 4px;
	padding: 10px 21px 12px;
	margin-top: 50px;
	display: inline-block;
	word-break: break-word;
}

.NewsBox-innerWidth-bHxkN {
	max-width: 545px;
	position: relative;
}

.NewsBox-bg-EYklG::before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: transparent -webkit-gradient(linear, left top, right top, from(#1A0000B8), to(#66545400)) 0% 0% no-repeat padding-box;
	background: transparent linear-gradient(90deg, #1A0000B8 0%, #66545400 100%) 0% 0% no-repeat padding-box;
	border-radius: 22px;

}

.NewsBox-siteColor-qoo8c {
	color: var(--primary-bg);
}

@media (max-width: 1199px) and (min-width: 768px) {
	.NewsBox-table-sOB2I {
		padding-top: 35px;
		padding-left: 24px;
		padding-right: 24px;
	}

	.NewsBox-title-C4Drf {
		font-size: 26px;
	}
}

@media (max-width: 1023px) and (min-width: 768px) {
	.NewsBox-bg-EYklG {
		padding: 40px;
	}
}

@media screen and (max-width: 767px) {
	.NewsBox-tableCell-wp2SP {
		display: block;
		width: 100%;
	}

	.NewsBox-desktopView-Kv55X {
		display: none;
	}

	.NewsBox-mobileView-b8PhA {
		display: block;
	}

	.NewsBox-textColumn-h0xIi {
		padding: 24px 0px 0px;
	}

	.NewsBox-title-C4Drf {
		font-size: 40px;
		line-height: 46px;
	}

	.NewsBox-caption-XVdPj {
		color: var(--primary-foreground);
		margin-top: 8px;
		margin-bottom: 16px;
		word-wrap: break-word;
		font-size: 16px;
		line-height: 24px;
		padding-top: 0px;
		padding-bottom: 0px;
	}

	.NewsBox-imgShadow-Txmac {
		width: 100%;
	}

	.NewsBox-bg-EYklG {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		    -ms-flex-align: center;
		        align-items: center;
		padding: 30px;
	}


}

/** News box - Start */`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Home/NewsBox/NewsBox.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA,qBAAqB;;AACrB;;;CAGC,qBAAqB;CACrB,eAAe;AAChB;;AAEA,mBAAmB;;AACnB,sBAAsB;;AACtB;CACC,WAAW;CACX,cAAc;CACd,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;CACV,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,6CAA6C;CAC7C,WAAW;CACX,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,gCAAgC;CAChC,gBAAgB;CAChB,mBAAmB;CACnB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,sBAAsB;CACtB,4BAA4B;CAC5B,4BAA4B;CAC5B,mBAAmB;CACnB,aAAa;CACb,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,gBAAgB;CAChB,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,iIAAwG;CAAxG,wGAAwG;CACxG,mBAAmB;;AAEpB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC;EACC,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,cAAc;EACd,WAAW;CACZ;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;CACpB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,aAAa;CACd;;;AAGD;;AAEA,sBAAsB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../helpers.css';\n\n/** Common - Start **/\na,\na:hover,\na:active a:focus {\n\ttext-decoration: none;\n\tcursor: pointer;\n}\n\n/** Common - End **/\n/** News box - Start */\n.table {\n\twidth: 100%;\n\tdisplay: table;\n\tmargin-bottom: 48px;\n\tpadding-top: 35px;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.textColumn {\n\twidth: 45%;\n\tpadding-right: 80px;\n}\n\n.imageColumn {\n\twidth: 55%;\n}\n\n.imgShadow {\n\twidth: 70%;\n\tfloat: right;\n}\n\n.title {\n\tfont-weight: 600;\n\tcolor: var(--common-primary-white-foreground);\n\tmargin: 0px;\n\tfont-size: 55px;\n\tline-height: 65px;\n}\n\n.caption {\n\tfont-weight: 200;\n\tcolor: var(--primary-foreground);\n\tmargin-top: 12px;\n\tmargin-bottom: 24px;\n\tword-wrap: break-word;\n\tfont-size: 19px;\n\tline-height: 24px;\n\tpadding-top: 0px;\n\tpadding-bottom: 0px;\n}\n\n.mobileView {\n\tdisplay: none;\n}\n\n.bg {\n\twidth: 100%;\n\tmin-height: 400px;\n\tbackground-size: cover;\n\tbackground-position: 50% 50%;\n\tbackground-repeat: no-repeat;\n\tborder-radius: 22px;\n\tpadding: 70px;\n\tposition: relative;\n\toverflow: hidden;\n}\n\n.btn {\n\tborder-radius: 4px;\n\tpadding: 10px 21px 12px;\n\tmargin-top: 50px;\n\tdisplay: inline-block;\n\tword-break: break-word;\n}\n\n.innerWidth {\n\tmax-width: 545px;\n\tposition: relative;\n}\n\n.bg::before {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground: transparent linear-gradient(90deg, #1A0000B8 0%, #66545400 100%) 0% 0% no-repeat padding-box;\n\tborder-radius: 22px;\n\n}\n\n.siteColor {\n\tcolor: var(--primary-bg);\n}\n\n@media (max-width: 1199px) and (min-width: 768px) {\n\t.table {\n\t\tpadding-top: 35px;\n\t\tpadding-left: 24px;\n\t\tpadding-right: 24px;\n\t}\n\n\t.title {\n\t\tfont-size: 26px;\n\t}\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\t.bg {\n\t\tpadding: 40px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.tableCell {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t}\n\n\t.desktopView {\n\t\tdisplay: none;\n\t}\n\n\t.mobileView {\n\t\tdisplay: block;\n\t}\n\n\t.textColumn {\n\t\tpadding: 24px 0px 0px;\n\t}\n\n\t.title {\n\t\tfont-size: 40px;\n\t\tline-height: 46px;\n\t}\n\n\t.caption {\n\t\tcolor: var(--primary-foreground);\n\t\tmargin-top: 8px;\n\t\tmargin-bottom: 16px;\n\t\tword-wrap: break-word;\n\t\tfont-size: 16px;\n\t\tline-height: 24px;\n\t\tpadding-top: 0px;\n\t\tpadding-bottom: 0px;\n\t}\n\n\t.imgShadow {\n\t\twidth: 100%;\n\t}\n\n\t.bg {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 30px;\n\t}\n\n\n}\n\n/** News box - Start */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `NewsBox-space1-WFrzr`,
	"space2": `NewsBox-space2-sl3Qm`,
	"space3": `NewsBox-space3-T7IST`,
	"space4": `NewsBox-space4-_r4n6`,
	"space5": `NewsBox-space5-yIDEX`,
	"space6": `NewsBox-space6-crl3O`,
	"space7": `NewsBox-space7-HbYOZ`,
	"spaceTop8": `NewsBox-spaceTop8-uBrZp`,
	"spaceTop1": `NewsBox-spaceTop1-PhIqr`,
	"spaceTop2": `NewsBox-spaceTop2-VUPxo`,
	"spaceTop3": `NewsBox-spaceTop3-qKpsV`,
	"spaceTop4": `NewsBox-spaceTop4-ksfKC`,
	"spaceTop5": `NewsBox-spaceTop5-ANz3e`,
	"spaceTop6": `NewsBox-spaceTop6-F64bo`,
	"spaceTop7": `NewsBox-spaceTop7-BHTTo`,
	"noMargin": `NewsBox-noMargin-jfCcv`,
	"padding1": `NewsBox-padding1-_3kgR`,
	"padding2": `NewsBox-padding2-SDshh`,
	"padding3": `NewsBox-padding3-NKe6k`,
	"padding4": `NewsBox-padding4-8fA25`,
	"padding5": `NewsBox-padding5-e5UFW`,
	"padding6": `NewsBox-padding6-jJUXQ`,
	"padding7": `NewsBox-padding7-lc8LD`,
	"paddingTop1": `NewsBox-paddingTop1-qpCny`,
	"paddingTop2": `NewsBox-paddingTop2-RlTDU`,
	"paddingTop3": `NewsBox-paddingTop3-J5s7Q`,
	"paddingTop4": `NewsBox-paddingTop4-_7q1_`,
	"paddingTop5": `NewsBox-paddingTop5-fw3RG`,
	"paddingTop6": `NewsBox-paddingTop6-uy5Mp`,
	"paddingTop7": `NewsBox-paddingTop7-ZbKMC`,
	"noPadding": `NewsBox-noPadding-IRBOZ`,
	"textBold": `NewsBox-textBold-BYkk_`,
	"textBolder": `NewsBox-textBolder-BX2X6`,
	"textNormal": `NewsBox-textNormal-zlt1g`,
	"spaceBottom20": `NewsBox-spaceBottom20-up41Q`,
	"spaceBottom10": `NewsBox-spaceBottom10-Yl2CZ`,
	"marginNone": `NewsBox-marginNone-Y_VyF`,
	"spaceBottom15": `NewsBox-spaceBottom15-Bc3xn`,
	"marginTopNone": `NewsBox-marginTopNone-XiCAP`,
	"spaceTop11": `NewsBox-spaceTop11-PxoeM`,
	"spaceTop21": `NewsBox-spaceTop21-SY6m_`,
	"spaceTop20": `NewsBox-spaceTop20-DCh9B`,
	"spaceTop10": `NewsBox-spaceTop10-LtlcG`,
	"textDarkBlue": `NewsBox-textDarkBlue-fvFCb`,
	"textLightBlue": `NewsBox-textLightBlue-RQJ03`,
	"textLightSandleGreen": `NewsBox-textLightSandleGreen-gB_am`,
	"textLightBrown": `NewsBox-textLightBrown-e4vGX`,
	"textMediumMaroon": `NewsBox-textMediumMaroon-9qM4a`,
	"textBrown": `NewsBox-textBrown-xZz7G`,
	"textMaroon": `NewsBox-textMaroon-k2Pwl`,
	"textDarkBrown": `NewsBox-textDarkBrown-PUL4J`,
	"textMediumBrown": `NewsBox-textMediumBrown-fHCDo`,
	"textSkyBlue": `NewsBox-textSkyBlue-dmnYi`,
	"textGray": `NewsBox-textGray-H_rnp`,
	"table": `NewsBox-table-sOB2I`,
	"tableCell": `NewsBox-tableCell-wp2SP`,
	"textColumn": `NewsBox-textColumn-h0xIi`,
	"imageColumn": `NewsBox-imageColumn-evJeR`,
	"imgShadow": `NewsBox-imgShadow-Txmac`,
	"title": `NewsBox-title-C4Drf`,
	"caption": `NewsBox-caption-XVdPj`,
	"mobileView": `NewsBox-mobileView-b8PhA`,
	"bg": `NewsBox-bg-EYklG`,
	"btn": `NewsBox-btn-b3XQU`,
	"innerWidth": `NewsBox-innerWidth-bHxkN`,
	"siteColor": `NewsBox-siteColor-qoo8c`,
	"desktopView": `NewsBox-desktopView-Kv55X`
};
module.exports = ___CSS_LOADER_EXPORT___;
